import React, { FC } from 'react';
import { useAuth, useMedia } from '../../selectors';
import { General } from './sections/General';
import { InsertedMedia } from './sections/insertedMedia/InsertedMedia';
import { Selection } from './sections/Selection';
import { OpenOptions } from './sections/openOptions/OpenOptions';
import { Transformations } from './sections/transformations/Transformations';
import { ClientSideDesign } from './sections/ClientSideDesign';

export const SettingsTab: FC = () => {
  const media = useMedia();
  const auth = useAuth();

  return (
    <div>
      <General auth={auth} />
      <ClientSideDesign />
      <InsertedMedia media={media || []} />
      <Selection />
      <Transformations />
      <OpenOptions />
    </div>
  );
};
